import commerceConfig from '@commerce/config'
import usePrice from '@commerce/product/use-price'
import processLocale from '@lib/locale'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { FC } from 'react'
interface props {
  name: string | undefined
  quantity?: string
  price: number
  currencyCode: string
  multiplePrice?: boolean
  selected?: boolean
}

const ProductOptionLabel: FC<props> = ({
  name,
  quantity,
  price,
  currencyCode,
  multiplePrice = true,
  selected,
}) => {
  const { locale } = useRouter()
  const { t } = useTranslation('common')
  const {
    config: { context },
  } = commerceConfig
  const currentLocale = processLocale(locale)
  const currentContext = context?.[currentLocale]
  const taxAmount = currentContext?.taxAmount
  const priceLocale = usePrice({
    amount: price,
    currencyCode: currencyCode,
    suffix: `(${t('excl-vat')})`,
    // suffix: `test`,
  })
  const afterTaxPriceLocale = usePrice({
    amount: price * (1 + taxAmount || 1),
    currencyCode: currencyCode,
    suffix: `(${t('incl-vat-approx')})`,
  })

  const i18nQuantity = quantity
    ?.replaceAll('litre', t('litre'))
    .replaceAll('li', 'Li')

  return (
    <div
      className={`flex w-full cursor-pointer items-center justify-between rounded border bg-white px-4 py-3.5 text-ui-dark-grey lg:px-6 ${
        selected ? 'border-ui-dark-grey' : 'border-ui-grey-25'
      }`}
    >
      <div className="body-2-bold ">
        {t(`${name?.replaceAll(' ', '-').toLowerCase()}`)}
      </div>
      <div className="body-2 flex flex-col text-right">
        <div>
          <span>{i18nQuantity}</span>
          {quantity && ' | '}
          {multiplePrice && ` ${t('from')} `}
          <span>{priceLocale.price}</span>
        </div>
        {taxAmount && <div>{afterTaxPriceLocale.price}</div>}
      </div>
    </div>
  )
}

export default ProductOptionLabel
